import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'

import {
  LANDING_CONTENT_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import Gallery from './Gallery'
import { Container } from './styles'

function LatestEventsSection() {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container
          gap={LANDING_SECTION_GAP}
          pb={LANDING_SECTION_PY}
          px={LANDING_CONTENT_PX}
        >
          <SubsectionTitle
            centered
            title="Ready to get on the fairways at an Emajin event?"
          />

          <Gallery />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default LatestEventsSection
